module.exports = __webpack_public_path__ + "resources/img/img_ai_fashion_m.5f25144d6fa5c62db9cdc30f08f2d2d0.png";